var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bwi",attrs:{"variant":_vm.variant,"disabled":_vm.disabled},on:{"click":_vm.click_handler}},[_c('div',{staticClass:"bwi--text",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('div',{staticClass:"bwi--icon",domProps:{"innerHTML":_vm._s(_vm.icon)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }